<template>

  <fragment>

    <slot></slot>


    <div class="sm-container">
      <div class="section">
        <div class="container-fluid">
            <slot name="title"></slot>

          <form action="" id="reg-form" autocomplete="off" >
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">First Name</label>
                  <div class="control">
                    <input class="input" vrules="required" v-model="formData.first_name" type="text"
                           placeholder="First Name">
                  </div>
                  <div class="help is-danger vrule" rule="required">
                    This field is required.
                  </div>
                </div>

              </div>
              <div class="column">
                <div class="field">
                  <label class="label">Last Name</label>
                  <div class="control">
                    <input class="input" vrules="required" v-model="formData.last_name" type="text"
                           placeholder="Last Name">
                  </div>
                  <div class="help is-danger vrule" rule="required">
                    This field is required.
                  </div>
                </div>

              </div>
            </div>
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">Email</label>
                  <div class="control">
                    <input autocomplete="off" class="input" vrules="required|email"
                           v-model="formData.email"
                           type="text"
                           placeholder="Email">
                  </div>
                  <div class="help is-danger vrule" rule="email">
                    Please enter a valid email address.
                  </div>
                </div>

              </div>
            </div>
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="label">Password</label>
                  <div class="control">
                    <input class="input" vrules="required|password" type="password"
                           v-model="formData.password"
                           placeholder="Password" autocomplete="new-password">
                  </div>
                  <div class="help is-danger vrule" rule="required">
                    This field is required.
                  </div>
                  <div class="help is-danger vrule" rule="password">
                    Password must be at least 8 characters.
                  </div>
                </div>

              </div>
            </div>
            <div class="columns">
              <div class="column">
                <div class="field">
                  <label class="checkbox columns is-mobile">
                    <div class="column agreement-checkbox">
                      <input vrules="required" type="checkbox" value="1">
                    </div>
                    <div class="column">
                      I agree to Startup Falcon’s <router-link target="_blank"  :to="{'name':'tos'}">Terms</router-link>,
                      <router-link target="_blank" :to="{'name':'privacy'}"  >User Agreement & Privacy Policy</router-link>.
                    </div>
                  </label>
                  <div class="help is-danger vrule" rule="required">
                    You must agree to Startup Falcon’s Terms.
                  </div>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <button @click.prevent="register()"
                        :class="{'is-loading': loading, 'is-disabled': loading,  }"
                        :style="{backgroundColor:ctaBackgroundColor}"
                        class="button btn-block-with-icon is-fullwidth is-primary">
                  Sign up with email
                </button>
              </div>
            </div>
          </form>
          <div class="sep-32 is-hidden-desktop"></div>
          <div class="columns is-mobile is-hidden-desktop">
            <div class="column text-center mobile-login">

              <span>Already registered?</span>
              <router-link :to="{'name': 'users_login'}" class="button">Login</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fragment>


</template>

<script>
import {LoginAPI} from "../../../apis/LoginAPI";
import {mapActions} from "vuex";
import LoginHeader from "../../../shared/components/LoginHeader";
import {FormValidation} from "../../../shared/directives/formValidation";
import {getCookie, parseResponseErrors} from "../../../shared/utils";
import GoogleLogin from "../components/GoogleLogin";
import FacebookLogin from "../components/FacebookLogin";
import {STORE_QUERY_PARAMS} from "@/router/constants";

export default {
  props: ['signup-success', 'ctaBackgroundColor'],
  components: {LoginHeader, GoogleLogin, FacebookLogin},
  data() {
    return {
      formData: {},
      loading: false,
      selectedPlan: null
    }
  },
  mounted() {
    this.selectedPlan = this.$route.params.priceId;
  },
  methods: {

    async register() {
      this.loading = true;
      let formValidation = new FormValidation('#reg-form')
      if (!formValidation.runAllValidations()) {
        this.loading = false;
        return;
      }
      let resp = await LoginAPI.registerUser(this.formData);

      if (resp.errors) {
        this.loading = false;
        let errorMsg = parseResponseErrors(resp.errors);
        this.$toasted.show(errorMsg, {
          theme: "bubble",
          position: "top-center",
          duration: 4000,
          className: 'falcon-toasted',
        });
      } else {
        if(typeof analytics !== "undefined" && analytics.identify){
          let identityObj =  {...resp.user};
          STORE_QUERY_PARAMS.forEach((queryParam) => {
            let queryParamValue = getCookie(queryParam);
            if (queryParamValue) {
              identityObj[queryParam] = queryParamValue
            }
          });
          analytics.identify(resp.user.id, identityObj);
        }
        this.loading = false;
        this.$emit('signup-success')
        // this.$router.push({
        //   name: 'user-type',
        //   query: {
        //     priceId: this.selectedPlan
        //   }
        // });
        // if (this.selectedPlan) {
        //   this.$router.push({
        //     name: 'checkout',
        //     params: {
        //       priceId: this.selectedPlan
        //     }
        //   });
        // } else {

        // }
      }
    },
  },

};
</script>

<style lang="scss" scoped>
.agreement-checkbox {
  width: 25px;
  text-align: center;
  flex: none;

  input {
    position: relative;
    top: 10px;
  }
}
</style>
